module.exports = __webpack_public_path__ + "img/emoji_14.75ece3f3.png";